import { gql } from 'apollo-angular';

const GET_CONTRACT_CATEGORIZATION_SCHEMES = gql`
  query contractCategorizationSchemes {
    contractCategorizationSchemes {
      id
      name
      type
    }
  }
`;

export default GET_CONTRACT_CATEGORIZATION_SCHEMES;
